export default {
  myInfo: process.env.BASE_URL + '/api/modules/eleven2019/my_info',
  friendInfo: process.env.BASE_URL + '/api/modules/eleven2019/friend_info',
  getAward: process.env.BASE_URL + '/api/modules/eleven2019/get_award',
  support: process.env.BASE_URL + '/api/modules/eleven2019/help',
  share: process.env.BASE_URL + '/api/modules/eleven2019/share',
  getAvatar: process.env.BASE_URL + '/api/modules/eleven2019/get_head',
  sendSms: process.env.BASE_URL + '/api/modules/eleven2019/send_sms',
  getJoinCount: process.env.BASE_URL + '/api/modules/eleven2019/get_join_count',
  signUp: process.env.BASE_URL + '/api/modules/eleven2019/submit'
}